import { keyMirror } from 'ramda-extension';

export const APP_CONTEXT_REDUCER_NAME = 'appContext';

export const appContextActionTypes = keyMirror({
	MERGE_CONTEXT_DEEP: null,
});
